export class DateHelper {
    public static getNow (): Date {
        return new Date();
    }
}